import { legalAcceptanceRequired, presentLegalAcceptance } from "../legal_acceptance.js"
import { Controller } from "@hotwired/stimulus"

const POLL_INTERVAL_MS = 1000

export default class extends Controller {
  static values = { url: String, label: String }

  connect() {
    this.poll()
  }

  disconnect() {
    window.clearTimeout(this.timer)
    this.abortController?.abort()
  }

  async poll() {
    this.abortController = new AbortController()

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        signal: this.abortController.signal
      })
      const legal = await legalAcceptanceRequired(response)
      if (legal) {
        presentLegalAcceptance(legal)
        return
      }
      if (!response.ok) throw new Error(`Request failed with ${response.status}`)

      const result = await response.json()
      if (result.status !== "processing") {
        window.Turbo.visit(window.location.href, { action: "replace" })
        return
      }

      this.element.textContent = `${this.labelValue} · ${result.progress}%`
    } catch (error) {
      if (error.name === "AbortError") return
      console.debug("Unable to refresh document processing progress", error)
    }

    this.timer = window.setTimeout(() => this.poll(), POLL_INTERVAL_MS)
  }
}
